import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import client from "../../../assets/images/client.jpg";
import Star from "./star";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
// import PickupDate from '../../../assets/images/pickup-date.png';
// import BookYourCar from '../../../assets/images/book-your-car.png';

//for redux and saga
import { connect } from 'react-redux';
import { getHowItWork } from '../../../redux/actions'
import { getTestimonial } from '../../../redux/actions'

const Testimonial = (props) => {
  const { getTestimonialAction, getTestimonialList, loading, error, messages } = props
  // const [howItWorkData, setHowItWorkData] = useState([])

  console.log("check---", getTestimonialList, loading, error, messages)

  React.useEffect(() => {
    // alert('calld')
    fetchData()
  }, [])

  const fetchData = () => {
    // alert("hello")
    getTestimonialAction(1)
  }

  return (
    <>
    {getTestimonialList.length > 0
      ?
      <section className="our-testimonials pt-100 pb-70">  
      <Container>
        <Row>
          <Col md={12}>
            <h2 className="main-title">Happy Customers</h2>
          </Col>
        </Row>
        <Row className="justify-content-center pt-30">
          <Col md={12}>
            <Swiper
              slidesPerView={1}
              spaceBetween={20}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                576: {
                  // width: 576,
                  slidesPerView: 2,
                },
                768: {
                  // width: 768,
                  slidesPerView: 2,
                },
                1024: {
                  // width: 768,
                  slidesPerView: 4,
                },
              }}
              modules={[Pagination]}
              className="mySwiper"
            >

              {getTestimonialList && getTestimonialList.map((item) => (
              <SwiperSlide className="p-1 swiper-slider-wrap ">
                <div className="p-3  slider-main">
                  <figure class="swiper-slider">
                    <div class="customer">
                      <div className="customer-wrap">
                        <img src={client} alt="client" />
                      </div>
                      <h5>
                        {item.UserName}{" "}
                        <span className="user-date">17th Nov 2022</span>
                      </h5>
                      <div className="star-rating">
                      <Box>
                        {[...new Array(5)].map((arr, index) => {
                          return index < item.Rate ? <StarIcon /> : <StarBorderIcon />;
                        })}
                      </Box>
                      </div>

                      <div className="customer-comment">
                        <p className="mt-3">
                          <span className="user-date"> {item.Description}{" "}</span>
                        </p>
                      </div>
                    </div>
                  </figure>
                </div>
              </SwiperSlide>
              ))}
              
            </Swiper>
          </Col>
          </Row>
          </Container>
    </section>
    : <section>

    </section>
  }
    </>
  );

}

//   export default HowitWork;
const mapStateToProps = ({ testimonial }) => {
  // console.log('======', howitwork);
  const { loading, error, messages, getTestimonialList } = testimonial;
  return { loading, error, messages, getTestimonialList };
};

export default connect(mapStateToProps, {
  getTestimonialAction: getTestimonial,
})(Testimonial);

